<div class="footer">
  <div class="footer-icon-list">
    <div>
      <a href="https://occon.de" target="_blank" rel="noopener" title="occon">
        <img
          class="icon-img"
          src="assets/img/logos/OCCON.png"
          alt="occon_logo"
        />
      </a>
    </div>
    <div>
      <a
        href="https://www.xing.com/companies/occongmbh"
        target="_blank"
        rel="noopener"
        title="xing"
      >
        <!-- TODO: Change to correct icon -->
        <img
          class="icon-img"
          src="assets/img/logos/xing.png"
          alt="occon_logo"
        />
      </a>
    </div>
    <div>
      <div class="footer-ring">
        <a
          href="https://twitter.com/OCCON"
          target="_blank"
          rel="noopener"
          title="(e)x-twitter"
        >
          <!-- TODO: Change to correct icon -->
          <i class="pi pi-twitter"></i>
        </a>
      </div>
    </div>
    <div>
      <div class="footer-ring">
        <a
          href="https://www.linkedin.com/company/occon-gmbh"
          target="_blank"
          rel="noopener"
          title="linkedin"
        >
          <!-- TODO: Change to correct icon -->
          <i class="pi pi-linkedin"></i>
        </a>
      </div>
    </div>
  </div>

  <div class="footer-data">
    <div>
      {{ "GENERAL.APP_VERSION" | translate : locale.language }} {{ version }}
    </div>
    <div>© OCCON GmbH {{ year }}</div>
    <div>
      <strong>
        <a (click)="showImprint = true" class="cursor-pointer">
          {{ "GENERAL.IMPRINT" | translate : locale.language }}
        </a>
        |
        <a (click)="showDisclaimer = true" class="cursor-pointer">
          {{ "GENERAL.DISCLAIMER" | translate : locale.language }}
        </a>
      </strong>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showImprint"
  styleClass="modal modal-lg"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
>
  <p-header>
    <span>{{ "GENERAL.IMPRINT" | translate : locale.language }}</span>
  </p-header>
  <supplierDB-registration-imprint />
  <p-footer>
    <p-button (click)="showImprint = false" severity="secondary">
      {{ "GENERAL.OK" | translate : locale.language }}
    </p-button>
  </p-footer>
</p-dialog>

<p-dialog
  [(visible)]="showDisclaimer"
  styleClass="modal modal-lg"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
>
  <p-header>
    <span>{{ "GENERAL.DISCLAIMER" | translate : locale.language }}</span>
  </p-header>
  <supplierDB-registration-disclaimer />
  <p-footer>
    <p-button (click)="showDisclaimer = false" severity="secondary">
      {{ "GENERAL.OK" | translate : locale.language }}
    </p-button>
  </p-footer>
</p-dialog>
